// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigations_navigation__17Cm1","active":"Navigations_active__22cSa","red":"Navigations_red__2cARW","white":"Navigations_white__12K4w"};